import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';

function DeleteModal({
  title,
  message,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const t = useTranslations('common');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth='lg:max-w-[630px] max-sm:max-w-11/12 max-md:max-w-[450px] max-lg:max-w-[500px]'
      headerTitleClassName='pt-[13px] pb-[15px] max-sm:px-[15px] max-md:px-[25px] max-lg:px-[31px] lg:px-[37px]'
      titleClassName='!font-bold text-xl max-sm:text-base max-lg:text-lg'
      closeClassName='max-sm:size-5 max-md:size-6'
    >
      <div className='text-center max-lg:px-5.5 max-lg:pb-5.5 max-md:px-4.5 max-sm:px-3.5 lg:px-[27px] lg:pb-6'>
        <p className='max-md:[13px] font-semibold max-lg:mt-5.5 max-lg:mb-7 max-lg:text-base max-md:mb-4 max-md:text-sm max-sm:mt-[7px] max-sm:mb-[11px] max-sm:text-xs lg:mt-7.5 lg:mb-12.5 lg:text-lg'>
          {message}
        </p>

        <div className='grid grid-cols-2 gap-[11px]'>
          <Button
            className='h-10 w-full font-bold max-lg:h-9 max-lg:!text-[15px] max-sm:!text-sm'
            onClick={onDelete}
            disabled={isDeleting}
          >
            {t('delete_key')}
            {isDeleting && <Spinner />}
          </Button>
          <Button
            onClick={onClose}
            disabled={isDeleting}
            className='!text-primary hover:!text-white disabled:!text-white border border-black bg-white font-bold max-lg:!text-[15px] max-sm:!text-sm'
          >
            {t('cancel_key')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
